import { createContext, Dispatch, FC, SetStateAction } from 'react';
import { css } from '@emotion/react';
import { MaintenanceMode } from '@frontend/empty-states#svg';
import { Trans, useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { Text, TextLink } from '@frontend/design-system';
import { trackingId } from '../../tracking';
import { defaultMediaID } from '../../utils/phone-utils';
import { MediaPickerOptionValues } from '../media-picker';
import { RoutingPayload } from './phone-routing-section/routing-section/routing-reducers';

type ContextType = { routingData: RoutingPayload; setRoutingData: Dispatch<SetStateAction<RoutingPayload>> };
export const RoutingSettingsContext = createContext<ContextType>({} as ContextType);

type Props = {
  departmentId: string | undefined;
  callRouteId: string | undefined;
};

export const PhoneRoutingSettings: FC<React.PropsWithChildren<Props>> = ({ callRouteId }) => {
  const { t } = useTranslation('phone');
  const { navigate } = useSettingsNavigate();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
      `}
    >
      <MaintenanceMode
        css={css`
          height: 500px;
        `}
      />
      <Trans t={t}>
        <Text color='subdued'>
          This content can now be accessed in the new{' '}
          <TextLink
            onClick={() => {
              if (callRouteId) {
                navigate({ to: `/phone/call-routes/:id`, params: { id: callRouteId } });
                return;
              }
              navigate({ to: '/phone/call-routes' });
            }}
            trackingId={trackingId({
              context: 'setting',
              feature: 'departments',
              details: 'call-routes-link',
            })}
          >
            Call Routes
          </TextLink>{' '}
          experience.
        </Text>
      </Trans>
    </div>
  );
};

// To manipulate media values in intermediate stage for VMO dropdown
export const getMediaValues = (mediaID: string) => {
  if (mediaID === defaultMediaID || mediaID === MediaPickerOptionValues.DEFAULT_GREETING) {
    return '';
  }
  return mediaID;
};
